import React from 'react';
import Lottie from 'react-lottie';

type Props = {
  animationData: unknown;
  height?: number;
  width?: number;
  isClickToPauseDisabled?: boolean;
  options?: Partial<React.ComponentProps<typeof Lottie>['options']>;
};

export type ImplementerProps = Omit<Props, 'animationData'>;

export const TemplateLottie: React.FC<Props> = ({
  options,
  isClickToPauseDisabled = true,
  animationData,
  ...otherProps
}) => {
  const mergedOptions = {
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
    autoplay: true,
    loop: false,
    ...options,
    animationData,
  };

  return (
    <Lottie
      isClickToPauseDisabled={isClickToPauseDisabled}
      options={mergedOptions}
      {...otherProps}
    />
  );
};
